<template functional>
  <span
    :aria-hidden="props.decorative"
    :aria-label="props.title"
    :class="[data.class, data.staticClass]"
    v-bind="data.attrs"
    class="material-design-icon access-point-off-icon"
    role="img"
    v-on="listeners">
    <svg
      :fill="props.fillColor"
      :width="props.size"
      :height="props.size"
      class="material-design-icon__svg"
      viewBox="0 0 20 20">
      <path
        d="M12.5002 11.6673C10.2752 11.6673 5.8335 12.7757 5.8335 15.0007V16.6673H19.1668V15.0007C19.1668 12.7757 14.7252 11.6673 12.5002 11.6673ZM12.5002 10.0007C13.3842 10.0007 14.2321 9.64946 14.8572 9.02434C15.4823 8.39922 15.8335 7.55137 15.8335 6.66732C15.8335 5.78326 15.4823 4.93542 14.8572 4.31029C14.2321 3.68517 13.3842 3.33398 12.5002 3.33398C11.6161 3.33398 10.7683 3.68517 10.1431 4.31029C9.51802 4.93542 9.16683 5.78326 9.16683 6.66732C9.16683 7.55137 9.51802 8.39922 10.1431 9.02434C10.7683 9.64946 11.6161 10.0007 12.5002 10.0007ZM4.16683 11.0673L6.2085 12.309L5.66683 9.96732L7.50016 8.40065L5.09183 8.19232L4.16683 5.99232L3.22516 8.19232L0.833496 8.40065L2.65016 9.96732L2.0835 12.309L4.16683 11.0673Z" 
      />
    </svg>
  </span>
</template>

<script>
export default {
  name: "ModeratorMake",
  props: {
    title: {
      type: String,
      default: ""
    },
    decorative: {
      type: Boolean,
      default: false
    },
    fillColor: {
      type: String,
      default: "currentColor"
    },
    size: {
      type: Number,
      default: 24
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/icons/ModeratorMake.vue